module.exports = __webpack_public_path__ + "static/media/quickto-logo-circle--inactive.0825744c.svg";